module.exports = __webpack_public_path__ + "img/postgresql.a05b6e7e.png";